import React from 'react';
import Layout from '../../components/Layout';
import Product from './Product';
import { urlPrefix } from '../../helpers';
import {
  getSalesChannelBasketId,
  clearUserStorage,
  getSalesChannelId,
} from '../../helpers/userStorage';
import { getProductSingle, getProductStockInfo } from '../../actions/product';
import { getPagePresentationKeys } from '../../actions/page';
import getWrappings from '../../actions/wrapping';
import { setSalesChannel } from '../../actions/config';
import { getBasket } from '../../actions/basket';
import { SHOP_PATH, SALES_CHANNELS } from '../../constants';
import { hasSpecialCharacters } from '../../helpers/validator';

import ProductSkeleton from './ProductSkeleton';

const pageName = 'product';

async function action({ store }, { id, product }) {
  const hasSplChar = hasSpecialCharacters(id);
  if (hasSplChar) {
    return undefined;
  }
  const state = store.getState();
  const {
    intl: { countryCode, locale, currency },
    config: { salesChannelId: configSalesChannelId },
  } = state;
  let salesChannelId = getSalesChannelId();
  const { basketId } =
    getSalesChannelBasketId({
      salesChannelId,
      countryCode,
    }) || {};
  const { vouchers } = await store.dispatch(getBasket(basketId));
  if (
    salesChannelId &&
    salesChannelId !== SALES_CHANNELS.B2B &&
    salesChannelId !== SALES_CHANNELS.B2C &&
    !vouchers?.length
  ) {
    clearUserStorage();
    salesChannelId = SALES_CHANNELS.B2C;
    await store.dispatch(setSalesChannel(salesChannelId));
  }

  // need to make sure state.config has same salesChannelId as localStorage
  // to be sure product is available in this sales channel
  // getProductSingle action is using salesChannelId from config not from localStorage
  if (salesChannelId && salesChannelId !== configSalesChannelId) {
    await store.dispatch(setSalesChannel(salesChannelId));
  }
  const {
    data: {
      id: productId,
      title,
      excerpt,
      slug,
      metaTitle,
      metaDescription,
      redeemableInCountries,
    },
  } = await store.dispatch(getProductSingle(id));

  store.dispatch(getWrappings());

  store.dispatch(getProductStockInfo(id));

  if (!productId) {
    if (process.env.BROWSER) {
      return undefined;
    }
    // This is here because we want to read last Sales Channel from userStorage before we are sure productId is wrong
    // since we get productId undefined also when the redeem product is not in B2C channel (default channel)
    return {
      chunk: ['product'],
      component: (
        <Layout footer={false} footerBar={false} redeemOverview="productPage">
          <ProductSkeleton />
        </Layout>
      ),
    };
  }

  const redirect =
    slug !== product
      ? urlPrefix(`${SHOP_PATH}/${slug}/${productId}`, {
          locale,
          countryCode,
          currency,
        })
      : undefined;

  await store.dispatch(getPagePresentationKeys({ pageName }));

  return {
    chunks: ['product'],
    title: metaTitle || title,
    description: (metaDescription || excerpt || '').substring(0, 255) || title,
    alternateCountries: redeemableInCountries,
    component: (
      <Layout footer={false} footerBar={false} redeemOverview="productPage">
        <Product id={productId} />
      </Layout>
    ),
    redirect,
    // do not hydrate html on client side, instead overwrite with new client render
    forceRender: true,
    addCompanyMarkup: true,
    addProductMarkup: true,
  };
}

export default action;
